import React from 'react';
import { NavLink } from 'react-router-dom';
import { menuConfig } from './menuConfig';
import { CpuChipIcon, ArrowPathIcon } from '@heroicons/react/24/outline';

export default function SidebarMenu() {
  return (
    <nav className="flex-1 px-4 py-4 space-y-8">
      {menuConfig.map((section) => (
        <div key={section.label}>
          {section.label && (
            <h2 className="px-4 text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wider">
              {section.label}
            </h2>
          )}
          <div className="mt-2 space-y-1">
            {section.items.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `flex items-center px-4 py-2 text-sm rounded-lg transition-colors ${
                    isActive
                      ? 'bg-accent-primary/20 text-gray-700 dark:text-accent-primary font-medium shadow-sm'
                      : 'text-gray-700 hover:bg-gray-300/50 dark:text-gray-400 dark:hover:bg-dark-300 hover:text-gray-900 dark:hover:text-gray-200'
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    {item.icon && (
                      <span className={`mr-3 ${
                        isActive 
                          ? 'text-gray-700 dark:text-accent-primary' 
                          : 'text-gray-500 dark:text-gray-400'
                      }`}>
                        {item.icon}
                      </span>
                    )}
                    <span>{item.label}</span>
                  </>
                )}
              </NavLink>
            ))}
          </div>
        </div>
      ))}
    </nav>
  );
} 